import { DateTime } from 'luxon';

export const formatTimeFrom24HourTo12Hour = (time: string) => {
  return DateTime.fromISO(time).toFormat('h:mm a');
};
